<template>
  <div>
    <a-skeleton active v-if="loading" />
    <div v-else>
      <h4 v-if="data.name">
        {{ $t("etablissement.designation") + ": " + data.name }}
      </h4>
      <a-tag color="red" class="mb-2" v-if="data.length == 0">
        {{ $t("liste.nonInscrits") }}
      </a-tag>
      <a-tag color="cyan" class="mb-2" v-else>
        {{ data.mode == "M" ? $t("inscription.monthlyPayment") : $t("inscription.installmentPayment") }}
      </a-tag>
      <a-table
        :pagination="true"
        :data-source="feesData"
        :columns="columns"
        rowKey="_id"
      >
        <template slot="title">
          <div class="d-flex justify-content-between align-items-center">
            <span>{{ $t('paiement.fraisMensuel') }}</span>
            <a-button
              type="primary"
              size="small"
              :loading="loadingSave"
              @click="editScolarite()"
            >
              <a-icon type="edit" />{{ $t("all.edit") }}
            </a-button>
          </div>
        </template>
        <template slot="isPayed" slot-scope="text">
          <a-tag v-if="text.fullyPaid" color="green">
            <b>{{ $t("profil.payes") }}</b>
          </a-tag>
          <a-tag
            v-else-if="!text.fullyPaid && text.remaining > 0"
            color="orange"
          >
            <b
              >{{ $t("profil.paidWithAvance") }} (
              {{ $t("recette.restePayer") }} :
              {{ text.remaining.toFixed(2) }} )</b
            >
          </a-tag>
          <a-tag v-else color="red">
            <b>{{ $t("profil.nonPayes") }}</b>
          </a-tag>
        </template>
        <span slot="feeName" slot-scope="text, record">
          <p v-if="text == 'inscription'">
            {{ $t("inscription.inscription") }}
          </p>
          <p v-else>
            {{ formatFeeName(text, record.daily) }}
          </p>
        </span>
      </a-table>
    </div>

    <!-- Edit Scolarite Modal -->
    <edit-scolarite-modal
      :visible="editModalVisible"
      :scolarite-data="selectedScolarite"
      @close="closeEditModal"
      @updatePayment="handleUpdatePayment"
    />
  </div>
</template>

<script>
/* eslint-disable */

import { mapState } from "vuex";
import apiClient from "@/services/axios";
import Vue from "vue";
import VueRouter from "vue-router";
import moment from "moment";
Vue.use(VueRouter);
import { formatFeeName } from "@/utilities/settings";
import EditScolariteModal from "@/components/comptabilite/EditScolariteFeesModal.vue";

export default {
  props: {
    studentId: {
      required: true,
    },
  },
  computed: {
    ...mapState(["settings", "user"]),
    columns() {
      return [
        {
          title: this.$t("paiement.mois"),
          dataIndex: "feeName",
          key: "feeName",
          scopedSlots: {
            customRender: "feeName",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
        },
        {
          title: this.$t("profil.etat"),
          dataIndex: "isPayed",
          key: "isPayed",
          scopedSlots: {
            customRender: "isPayed",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          scopedSlots: { customRender: "isPayed" },

          sorter: (a, b) => a.status.length - b.status.length,
          sortDirections: ["descend", "ascend"],
        },
      ];
    },
  },
  components: {
    EditScolariteModal
  },
  async created() {
    this.$gtag.pageview({
      page_path: this.$route.path,
      page_location: window.location.href,
      page_title: document.title + " - " + this.$t("profil.paiementScol"),
    });
  },
  mounted() {
    const building = this.user.building.find(
      (el) => el.dbName == this.settings.activeBuilding
    );
    if (building) this.reductionType = building.reductionType || "pourcentage";

    /* if (this.reductionType == "dinar")
      this.columns[1].title = "Réduction (TND)";
    else this.columns[1].title = "Réduction (%)";*/

    this.fetchPayments();
  },

  data() {
    return {
      editingReduction: null,
      feesData: [],
      data: [],
      loading: true,
      loadingSave: false,
      moment,
      reductionType: "dinar",
      editModalVisible: false,
      selectedScolarite: null,
    };
  },
  methods: {
    formatFeeName,
    async fetchPayments() {
      this.visibleModal = true;
      this.loading = true;
      await apiClient
        .get("/payment/manager/pvalidator/" + this.studentId)
        .then((res) => {
          this.data = res.data.filter((p) => p.typeAS == "S");
          this.data = this.data[0] || [];
          this.feesData = this.data.fees || [];
        })
        .catch((err) => {
          console.error(err);
          this.feesData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    editScolarite() {
      this.selectedScolarite = this.data; // Pass the entire scolarite data
      this.editModalVisible = true;
    },

    closeEditModal() {
      this.editModalVisible = false;
      this.selectedScolarite = null;
    },

    async handleUpdatePayment() {
      try {
        this.loadingSave = true;
        // Refresh the payments data
        await this.fetchPayments();
      } catch (error) {
        this.$message.error(this.$t('error.modif'));
        console.error('Error updating payment:', error);
      } finally {
        this.loadingSave = false;
      }
    },
  },
};
</script>
